/*
 * Aviso de envio gratuito del carrito.
 *
 * 31-ago-2026: ademas de decir cuanto falta, propone el producto disponible MAS
 * BARATO que llega al umbral (excluyendo lo que ya esta en el carrito). La lista
 * de candidatos la sirve sections/ofm-gap-fillers.liquid y se pide una sola vez.
 * Si algo falla, se queda el aviso de siempre. Actuacion 2 del informe OFM-TDA-2608.
 */
if (typeof ShippingNotice != "function") {
  class ShippingNotice2 extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const freeShippingThreshold = Number(this.getAttribute("data-free-shipping")),
        freeShippingRemaining =
          Number(this.getAttribute("data-cart-total-amount")) -
          Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = "",
        shippingSuccess = !1;

      freeShippingRemaining < 0
        ? (shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace(
            "{{ remaining_amount }}",
            this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format)
          ))
        : ((shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free), (shippingSuccess = !0));

      /* 29-sep-2026: promo «Botella térmica de regalo» (snippets/ofm-promo-botella.liquid).
         Con el envío ya gratis, el aviso pasa al siguiente escalón: la botella. */
      const gift = this._gift();
      if (gift && gift.line && (!gift.active || gift.eligible < gift.threshold || gift.charged)) {
        /* La botella se añadió como regalo y ya no toca: fuera, o se cobraría a 14,90 €.
           «charged»: el cliente usa otro descuento que ahorra más y no se combina con este;
           entonces no se vuelve a ofrecer en esta visita. */
        /* Por debajo de 75 € la botella también sale cobrada: eso no es otro descuento. */
        if (gift.charged && gift.active && gift.eligible >= gift.threshold) ShippingNotice2._store("ofm-gift-blocked", "1");
        this._removeGift(gift.line);
      }
      let giftButton = !1;
      if (gift && gift.active && shippingSuccess && !ShippingNotice2._store("ofm-gift-blocked")) {
        if (gift.inCart && gift.eligible >= gift.threshold) {
          shippingMessage = "✓ Envío gratis · Botella térmica de regalo incluida";
        } else if (gift.eligible >= gift.threshold) {
          shippingMessage = "✓ Envío gratis + botella térmica de regalo";
          giftButton = !0;
        } else {
          shippingMessage =
            /* En un <span>: la caja del aviso de la página del carrito es flex y partiría el <strong> en columnas. */
            "<span>✓ Ya tienes envío gratis. Te faltan <strong>" +
            this._formatMoney(gift.threshold - gift.eligible, KROWN.settings.shop_money_format) +
            "</strong> para tu botella térmica de regalo.</span>";
        }
      }

      this.hasAttribute("data-show-alert")
        ? (this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? "success" : "note"}">
            ${shippingMessage}
          </div>`)
        : (this.innerHTML = shippingMessage);

      if (giftButton) this._addGiftButton(gift);
      if (!shippingSuccess) this._suggestGapFiller(Math.abs(freeShippingRemaining));
    }

    _gift() {
      if (!this.hasAttribute("data-gift-variant") || !this.getAttribute("data-gift-variant")) return null;
      return {
        active: this.getAttribute("data-gift-active") === "true",
        threshold: Number(this.getAttribute("data-gift-threshold")),
        variant: Number(this.getAttribute("data-gift-variant")),
        eligible: Number(this.getAttribute("data-gift-eligible")),
        inCart: this.getAttribute("data-gift-in-cart") === "true",
        line: Number(this.getAttribute("data-gift-line")) || 0,
        charged: this.getAttribute("data-gift-charged") === "true",
      };
    }

    static _store(key, value) {
      try {
        if (value === undefined) return window.sessionStorage.getItem(key);
        window.sessionStorage.setItem(key, value);
      } catch (e) {
        return null;
      }
    }

    _refreshCart() {
      const cartPage = window.location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, "").indexOf("/cart") === 0;
      if (!cartPage && document.querySelector('[data-js-site-cart-sidebar]') && typeof window.refreshCart === "function") {
        window.refreshCart();
      } else {
        window.location.reload();
      }
    }

    _removeGift(line) {
      /* El aviso aparece dos veces en la página del carrito: que solo lo quite uno. */
      if (ShippingNotice2._removing) return;
      ShippingNotice2._removing = !0;
      const self = this;
      fetch(KROWN.settings.routes.cart_change_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: 0 }),
      })
        .then(function (r) {
          /* Solo si Shopify la ha quitado: si no, recargar volvería a intentarlo en bucle. */
          if (r.ok) self._refreshCart();
        })
        .catch(function () {})
        .finally(function () {
          ShippingNotice2._removing = !1;
        });
    }

    _addGiftButton(gift) {
      const self = this;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "ofm-gift-add";
      /* Mismo dorado que el CTA de los banners OFM; el tema no trae un botón que se vea sobre este fondo. */
      btn.style.cssText =
        "margin-top:.6em;display:inline-flex;align-items:center;gap:.4em;background:#D9A13B;color:#2C2008;" +
        "border:0;border-radius:999px;padding:.65em 1.4em;font-weight:700;font-size:15px;line-height:1.2;cursor:pointer;";
      btn.textContent = "🎁 Añadir mi botella gratis";
      btn.addEventListener("click", function () {
        btn.disabled = !0;
        btn.textContent = "Añadiendo…";
        fetch(KROWN.settings.routes.cart_add_url + ".js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({
            items: [{ id: gift.variant, quantity: 1, properties: { _regalo: "botella-termica" } }],
          }),
        })
          .then(function (r) {
            if (!r.ok) throw new Error("add");
            self._refreshCart();
          })
          .catch(function () {
            btn.disabled = !1;
            btn.textContent = "No se ha podido añadir. Inténtalo de nuevo";
          });
      });

      const box = this.querySelector(".alert");
      if (box) {
        if (getComputedStyle(box).display.indexOf("flex") !== -1) box.style.flexWrap = "wrap";
        const wrap = document.createElement("div");
        wrap.style.flexBasis = "100%";
        wrap.style.width = "100%";
        wrap.appendChild(btn);
        box.appendChild(wrap);
      } else {
        const wrap = document.createElement("div");
        wrap.appendChild(btn);
        this.appendChild(wrap);
      }
    }

    static _candidates() {
      if (!ShippingNotice2._cache) {
        ShippingNotice2._cache = fetch("/?section_id=ofm-gap-fillers")
          .then(function (r) {
            return r.text();
          })
          .then(function (t) {
            const el = new DOMParser().parseFromString(t, "text/html").getElementById("ofm-gap-fillers");
            return el ? JSON.parse(el.textContent) : [];
          })
          .catch(function () {
            return [];
          });
      }
      return ShippingNotice2._cache;
    }

    _suggestGapFiller(remaining) {
      const self = this;
      ShippingNotice2._candidates()
        .then(function (candidates) {
          if (!candidates || !candidates.length) return;

          const inCart = new Set(
            Array.from(document.querySelectorAll("[data-js-cart-item]")).map(function (el) {
              return String(el.dataset.productId);
            })
          );

          const pick = candidates
            .filter(function (c) {
              return c.p >= remaining && !inCart.has(String(c.id));
            })
            .sort(function (a, b) {
              return a.p - b.p;
            })[0];
          if (!pick) return;

          const wrap = document.createElement("div");
          wrap.className = "ofm-gap-suggestion text-size--small";
          wrap.style.marginTop = ".4em";

          const link = document.createElement("a");
          link.href = pick.u;
          link.className = "text-animation--underline-thin";
          const strong = document.createElement("strong");
          /* El tema capitaliza cada palabra de los <strong>: sin esto el nombre sale
             como «Botella Termica De Acero Inoxidable De Doble Capa». */
          strong.style.textTransform = "none";
          strong.textContent = pick.t;
          link.appendChild(strong);

          wrap.appendChild(document.createTextNode("Añade "));
          wrap.appendChild(link);
          wrap.appendChild(
            document.createTextNode(
              " (" + self._formatMoney(pick.p, KROWN.settings.shop_money_format) + ") y el envío te sale gratis."
            )
          );

          /* Dentro de la caja del aviso cuando la hay (pagina del carrito). Esa caja
             es flex: sin forzar linea entera, la sugerencia se pone de segunda
             columna y parte las dos frases en dos tiras estrechas. */
          const box = self.querySelector(".alert");
          if (box) {
            if (getComputedStyle(box).display.indexOf("flex") !== -1) box.style.flexWrap = "wrap";
            wrap.style.flexBasis = "100%";
            wrap.style.width = "100%";
            box.appendChild(wrap);
          } else {
            self.appendChild(wrap);
          }
        })
        .catch(function () {
          /* si algo falla, se queda el aviso de siempre */
        });
    }

    _formatMoney(cents, format) {
      typeof cents == "string" && (cents = cents.replace(".", ""));
      let value = "";
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || moneyFormat;
      function formatWithDelimiters(number, precision, thousands, decimal) {
        if (((thousands = thousands || ","), (decimal = decimal || "."), isNaN(number) || number === null)) return 0;
        number = (number / 100).toFixed(precision);
        const parts = number.split("."),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
      }
      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }
      return formatString.replace(placeholderRegex, value);
    }
  }
  typeof customElements.get("shipping-notice") > "u" && customElements.define("shipping-notice", ShippingNotice2);
}
